import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "dropdown"]
  static values = { blankText: String }

  connect() {
    this.closeOnOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.close();
    };
    document.addEventListener("click", this.closeOnOutsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick);
  }

  toggle() {
    this.dropdownTarget.classList.toggle("d-none");
  }

  close() {
    this.dropdownTarget.classList.add("d-none");
  }

  selection(event) {
    // The option lives inside the badge, which carries the `toggle` action. Stop the
    // click bubbling to it — otherwise its toggle re-opens the dropdown close() just closed.
    event.stopPropagation();
    const id = event.target.dataset.id;
    const name = event.target.textContent;

    if (id) {
      this.inputTarget.value = id;
      this.labelTarget.textContent = name;
    } else {
      this.inputTarget.value = "";
      this.labelTarget.textContent = this.blankTextValue;
    }

    // The form's htmx swap only re-renders the results, not the filter badges, so the
    // dropdown would otherwise stay open after choosing — close it before submitting.
    this.close();
    this.element.closest("form").requestSubmit();
  }
}
